import type { EntityState, EventImplementation } from './generated';

interface IRaceControlItem {
    AppealDeadline: EventImplementation | null;
    CategoryID: number;
    EventID: number;
    ID: string | null;
    IsOffical: EventImplementation | null;
    NumberOfDNX: number;
    NumberOfFinished: number;
    NumberOfStarted: number;
    NumContestants: number;
    OfficalPrinted: EventImplementation | null;
    RaceID: number;
    UnofficialPrinted: EventImplementation | null;
    LastFinished: Date | null;
    OfficialUnoffical: EventImplementation | null;

    /**
     * Contains a list of all the starting times for this item ordered ascending
     */
    StartingTimes: Date[];
}

export class RaceControlItem implements IRaceControlItem {
    public AppealDeadline: EventImplementation | null;
    public CategoryID: number;
    public EventID: number;
    public ID: string | null;
    public IsOffical: EventImplementation | null;
    public NumberOfDNX: number;
    public NumberOfFinished: number;
    public NumberOfStarted: number;
    public NumContestants: number;
    public OfficalPrinted: EventImplementation | null;
    public RaceID: number;
    public UnofficialPrinted: EventImplementation | null;
    public LastFinished: Date | null;
    public OfficialUnoffical: EventImplementation | null;
    public StartingTimes: Date[];

    public constructor(item?: IRaceControlItem) {
        this.AppealDeadline = item?.AppealDeadline ?? null;
        this.CategoryID = item?.CategoryID ?? 0;
        this.EventID = item?.EventID ?? 0;
        this.ID = item?.ID ?? null;
        this.IsOffical = item?.IsOffical ?? null;
        this.NumberOfDNX = item?.NumberOfDNX ?? 0;
        this.NumberOfFinished = item?.NumberOfFinished ?? 0;
        this.NumberOfStarted = item?.NumberOfStarted ?? 0;
        this.NumContestants = item?.NumContestants ?? 0;
        this.OfficalPrinted = item?.OfficalPrinted ?? null;
        this.RaceID = item?.RaceID ?? 0;
        this.UnofficialPrinted = item?.UnofficialPrinted ?? null;
        this.LastFinished = item?.LastFinished ?? null;
        this.OfficialUnoffical = item?.OfficialUnoffical ?? null;
        this.StartingTimes = item?.StartingTimes ?? [];
    }
}
